<template>
  <div class="home-section zen-experiential-spaces-block">
    <div class="container">
      <div class="body">
        <div class="text-block">
          <p>
            Introducing the Zenapptic
            <b>MULTI-PURPOSE EXPERIENTIAL SPACES</b>
            solution, created to make updating content in
            <b>Multi-Purpose Rooms</b>
            easier than ever.
          </p>

          <p>
            Easily
            <b>update any content</b>
            on
            <b>any screen</b>
            . Maximize audience engagement. No technical know-how required!
          </p>

          <div class="cta">
            <a :href="`${useCdnUrl()}/assets/experiential-spaces/ZENAPPTIC__MULTI-PURPOSE-EXPERIENTIAL-SPACES__09-15.pdf`" target="_blank" rel="noopener noreferrer">
              <button class="the-cta-button" aria-label="submit contact form">
                <div>Download Solution Sheet</div>
              </button>
            </a>
            <!-- <NuxtLink :to="`${useCdnUrl()}/assets/experiential-spaces/ZENAPPTIC__MULTI-PURPOSE-EXPERIENTIAL-SPACES__09-15.pdf`" target="_blank">Download Solution Sheet</NuxtLink> -->
          </div>
        </div>

        <div class="image-block">
          <img :src="`${useCdnUrl()}/assets/experiential-spaces/experiential-spaces-image.webp`" alt="zenapptic experiential spaces" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.zen-experiential-spaces-block {
  background-color: black !important;
  // border-top: 2px rgb(73, 70, 72) solid;
  // border-bottom: 2px rgb(73, 70, 72) solid;
  .container {
    margin: auto;
    max-width: 1366px;
    padding: 0;

    @media (max-width: 768px) {
      padding: 0;
    }

    .body {
      align-items: center;
      display: grid !important;
      grid-template-columns: 1fr 1fr;
      //gap: 5rem;
      padding: 0 !important;

      b {
        font-size: min(5vw, 3rem);
      }

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 0;
      }

      .text-block {
        padding: 10rem 3rem;

        @media (max-width: 768px) {
          padding: 3rem 3rem 6rem 3rem;
        }

        .cta {
          text-align: center;

          button.the-cta-button {
            background-color: transparent;
            border: 2px solid white;
            color: white;
            cursor: pointer;
            display: inline-block;
            margin: auto;
            padding: 1px;
            text-decoration: none;
            div {
              border: 1px solid white;
              font-size: 2rem;
              font-weight: 700;
              padding: 0.75rem 6rem;
              text-align: center;
            }

            &:hover {
              border-color: rgb(150, 150, 150);

              div {
                border-color: rgb(150, 150, 150);
              }
            }
          }
        }
      }

      .image-block {
        order: 1 !important;
        width: 100% !important;
        height: 100%;

        @media (max-width: 768px) {
          grid-row: 1 !important;
        }
        img {
          width: 100% !important;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
</style>
